import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from 'react-bootstrap';

export default class ActionCellRenderer extends Component {

  checkActions() {
    const data = this.props.data;
    let checkActionsResult;
    // If data type isn't document return normal form actions
    if (!data.type) {
      checkActionsResult = this.allActions();
    } else {
      checkActionsResult = this.documentUploaderActions();
    }
    return checkActionsResult;
  }

  documentUploaderActions() {
    return (
      <div>
        <Button className="table-btn" onClick={this.props.data.action.downloadHandler}>
          <Glyphicon glyph="download" />
        </Button>
        <Button className="table-btn" onClick={this.props.data.action.deleteHandler}>
          <Glyphicon glyph="trash" />
        </Button>
      </div>
    );
  }

  allActions() {
    return (
      <div>
        <Button className="table-btn" onClick={this.props.data.action.viewHandler}>
          <Glyphicon glyph="eye-open" />
        </Button>
        <Button className="table-btn" onClick={this.props.data.action.editHandler}>
          <Glyphicon glyph="pencil" />
        </Button>
        <Button className="table-btn" onClick={this.props.data.action.deleteHandler}>
          <Glyphicon glyph="trash" />
        </Button>
      </div>
    );
  }

  render() {
    const checkActions = this.checkActions();
    return (
      <div className="action-button-cell">{checkActions}</div>
    );
  }
}

ActionCellRenderer.propTypes = {
  data: PropTypes.shape({
    action: PropTypes.shape({
      viewHandler: PropTypes.func,
      editHandler: PropTypes.func,
      deleteHandler: PropTypes.func,
      downloadHandler: PropTypes.func,
    }),
  }).isRequired,
};
